import React, { FC, ReactNode } from 'react'
import { Stack, Typography } from '@mui/material'
import { useDevMode } from '@plug-core/state'
import { POPUP_DIMENSIONS } from '@misc/constants'
import useWindowDimensions from '@hooks/useWindowDimensions'

interface Props {
  children: ReactNode
}

const ExtensionContainer: FC<Props> = ({ children }) => {
  const { devEnabled } = useDevMode()
  const { height, width } = useWindowDimensions()

  return (
    <Stack
      height={Math.max(height, POPUP_DIMENSIONS.height)}
      width={Math.max(width, POPUP_DIMENSIONS.width)}
      overflow="hidden"
      position="relative"
    >
      {devEnabled && (
        <Stack
          alignItems="center"
          justifyContent="center"
          height={30}
          bgcolor={(theme) => theme.palette.background.paper}
        >
          <Typography>🧪 DEV MODE</Typography>
        </Stack>
      )}
      {children}
    </Stack>
  )
}

export default ExtensionContainer
